import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterB = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M13.784 11.644C14.312 11.26 14.636 10.66 14.636 9.928C14.636 8.584 13.532 7.6 12.176 7.6H8.84V16H12.44C13.832 16 14.96 14.992 14.96 13.6C14.96 12.7 14.492 12.016 13.784 11.644ZM12.176 8.896C12.788 8.896 13.256 9.376 13.256 10C13.256 10.624 12.788 11.104 12.176 11.104H10.22V8.896H12.176ZM12.44 14.704H10.22V12.352H12.44C13.088 12.352 13.58 12.868 13.58 13.528C13.58 14.188 13.088 14.704 12.44 14.704Z" }),
});

export { IconCapitalLetterB };
